import { getLocale, setLocale, useT } from "@/lib/i18n";
import { Globe } from "lucide-react";
import { useState } from "react";

export const LanguageToggle = () => {
  const t = useT();
  const [, force] = useState(0);
  const change = (loc) => {
    setLocale(loc);
    force((n) => n + 1);
  };
  const cur = getLocale();
  return (
    <div className="inline-flex items-center gap-1 rounded-full border" style={{ borderColor: "var(--hairline)", padding: 2 }} data-testid="language-toggle" title={t("common.language")}>
      <Globe size={11} className="hidden sm:block" style={{ color: "var(--muted)", marginLeft: 6 }} />
      {["en", "fr"].map((loc) => (
        <button
          key={loc}
          onClick={() => change(loc)}
          className="px-2 py-0.5 text-xs font-medium rounded-full"
          style={{
            background: cur === loc ? "var(--brand-green)" : "transparent",
            color: cur === loc ? "var(--white)" : "var(--muted)",
            fontFamily: "Montserrat, sans-serif",
          }}
          data-testid={`lang-${loc}`}
        >
          {loc.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
